/**
 * Dialog layout type — mirrors the Figma "Dialog" organism `Type` property
 * (file VFBn7KCDy3FSIlvhNo3ylq, 873:9194).
 *
 * - `'modal-leading-icon'`  — header row with an optional leading icon + title
 *                             and a close button, a projected body, and a
 *                             full-width split action footer. Widest surface.
 * - `'modal-centered-icon'` — a centered icon badge above a centered title +
 *                             description, with a full-width split action footer.
 * - `'alert'`               — compact: left-aligned title + description with the
 *                             actions right-aligned. Narrowest surface.
 */
export type DialogVariant = 'modal-leading-icon' | 'modal-centered-icon' | 'alert';
